import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addItem = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/resource/Item', body);
  return data;
});
export const updateItem = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(`/api/resource/Item/${id}`, body);
  return data;
});

export const getItem = catchAsync(async ({ key = '', value = '' }) => {
  let baseUrl =
    '/api/resource/Item?fields=["name","stock_uom","item_name","item_code","disabled","is_sales_item","is_purchase_item","item_group"]&limit_page_length=0';
  if (value) {
    baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
  }
  const { data } = await axiosInstance.get(baseUrl);
  return data;
});
export const deleteItem = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(`/api/resource/Item/${record}`);
  return data;
});
export const getItemListDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Item/${id}`);
  return data;
});

export const getSearchApi = catchAsync(async (type, filter = '', name = '') => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.search?type=${type}&${filter}&name=${name}`
    `/api/method/technoerp.services.search?type=${type}&fields=${filter}&name=${name}`
  );
  return data;
});
export const getSearchApiFilterDocstatus = catchAsync(
  async (type, filter = '', name = '') => {
    const { data } = await axiosInstance.get(
      // https://be-test.technoerplead.co/api/method/technoerp.services.search?type=Purchase Receipt&filters=[{"docstatus":1},{"is_return":0}]
      // `/api/method/technoerp.services.search?type=${type}&${filter}&name=${name}`
      `/api/method/technoerp.services.search?type=${type}&filters=[{"docstatus":1},{"is_return":0}]`
      // `/api/method/technoerp.services.search?type=Purchase Receipt&filters=[{"docstatus":1},{"is_return":0}]`
    );
    return data;
  }
);
export const getSearchApiAcount = catchAsync(
  async ({ type, filter = '', name = '', searchTxt = '', is_group = 0 }) => {
    const { data } = await axiosInstance.get(
      // `/api/method/technoerp.services.search?type=${type}&${filter}&name=${name}`
      `/api/method/technoerp.services.search?type=${type}&fields=${filter}&name=${name}&txt=${searchTxt}&filters={"is_group":${is_group}}`
    );
    return data;
  }
);
export const getSearchApiSearchText = catchAsync(
  async ({ type, searchTxt = '', name = '' }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.search?type=${type}&name=${name}&txt=${searchTxt}`
    );
    return data;
  }
);
export const getGetDetailsApi = catchAsync(
  async ({ type, fields = '', name = '' }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_data?type=${type}&name=${name}&fields=${JSON.stringify(
        fields
      )}`
    );
    return data;
  }
);
export const getSearchApiFilters = catchAsync(
  async (type, filter = '', name = '') => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.search?type=${type}&fields=["supplier","posting_date","base_grand_total"]&name=${name}&filters:[["docstatus","=","1"]]`
    );
    return data;
  }
);

export const getReceiptDocument = catchAsync(
  async (type = '', filter = '', name = '') => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.search?type=${type}&filters:[["docstatus","=","1"]]`
    );
    return data;
  }
);

export const getDataApi = catchAsync(async (type, filter = '', name = '') => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_data?type=${type}&fields=${filter}&name=${name}`
  );
  return data;
});
